import { Range, Transforms,  Node, Text, Path, Editor } from 'slate'
import isUrl from 'is-url'
import axios from 'axios'

import imageExtensions from './imageExtensions'
import { getAssetType } from '../contentstack/image/Modal/util'
import { handleUpload } from '../../../../lib/requestModule'
import { paramsSerializer } from "../../../../../../utils"

export const isSelectionCollapsed = (selection) => {
  return Range.isCollapsed(selection)
}
export const insertImage = async (editor, url, extraAttrs = {}) => {
  const selection = editor.selection || editor.savedSelection;

  let image;
  if (url.startsWith('data')) { // upload to assets

    let fileArray = url.split(','),
      mime = fileArray[0].match(/:(.*?);/)[1],
      bstr = atob(fileArray[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    const fileToUpload = new File([u8arr], 'image.png', { type: mime });
    const requestProps: Object = editor?.requestProps || {};
    const folderUid = ''
    const imgUploadRes: any = await uploadImage({ ...requestProps, files: [fileToUpload], folderUid })
    if (imgUploadRes) {
      const isImage = Array.from(imgUploadRes).some(instance => getAssetType(instance?.['asset']?.['content_type']) === null);

      if (isImage) {
        image = {
          type: 'img',
          attrs: {
            url: imgUploadRes[0].asset.url,
            width: null,
            height: 'auto',
            "redactor-attributes": { ...extraAttrs }
          },
          children: [{ text: '' }]
        }
      }
    }
  } else {
    const alt = extraAttrs["alt"] ?? ''
    delete extraAttrs["alt"]
    image = {
      type: 'img',
      attrs: {
        url,
        width: null,
        alt,
        height: 'auto',
        "redactor-attributes": { ...extraAttrs }
      },
      children: [{ text: '' }]
    }
  }
  if (selection)
    Transforms.insertNodes(editor, image, { at: selection });
  else Transforms.insertNodes(editor, image)
}

export const isImageUrl = (url) => {
  if (!url) return false
  if (!isUrl(url)) return false
  const ext = new URL(url).pathname.split('.').pop()
  return imageExtensions.includes(ext)
}

export const uploadImage = async (props) => {
  const { apiKey, assetUrl, authToken, files, folderUid, branch, isPlugin } = props
  let url = `${assetUrl}/assets`;

  if (isPlugin) {
    const res = await handleUpload(files, folderUid);
    return res.data;
  }
  return Promise.all(files.map(async file => {
    let formData = new FormData()
    formData.append('asset[upload]', file, file.name);
    formData.append('asset[parent_uid]', folderUid);
    const headers = {
      api_key: apiKey,
      'Content-Type': 'application/json'
    }
    authToken && (headers['authToken'] = authToken);
    branch && (headers['branch'] = branch);
    const res = await axios({
      method: 'POST',
      url,
      headers,
      data: formData,
      paramsSerializer
    });
    return res.data;
  }))
}

export const moveCursorToNextEmptyTextNode = (editor) => { 
  try {
    const { selection } = editor
    if (selection && Range.isCollapsed(selection)) {
      const selectionPath = selection?.anchor?.path
      const currNode = Node.get(editor, selectionPath)
      if (currNode && Text.isText(currNode) && currNode.text === '') {
        const nextNodePath = Path.next(selectionPath)
        if(!nextNodePath || !Node.has(editor, nextNodePath)) return
        const nextNode : any = Node.get(editor, nextNodePath)
        if (
          nextNode &&
          nextNode?.type === 'reference' &&
          nextNode?.attrs?.type === 'asset' &&
          nextNode?.attrs?.inline &&
          (nextNode?.attrs?.position === 'left' || nextNode?.attrs?.position === 'right')
        ) {
          const nextToNextNodePath = Path.next(nextNodePath)
          if(!nextToNextNodePath || !Node.has(editor, nextToNextNodePath)) return
          const nextToNextNode: any = Node.get(editor, nextToNextNodePath)
          if (nextToNextNode && Text.isText(nextToNextNode) && nextToNextNode.text === '') {
            Transforms.select(editor, nextToNextNodePath)
          }
        }
      }
    }
  } catch (e) { console.warn(e) }
}

export const getNewImageSize = (ratio, value, type) => {
  if (type === 'width') {
    return {
      width: value,
      height: value / ratio
    }
  } else if (type === 'height') {
    return {
      width: value * ratio,
      height: value
    }
  }
}

export function isPositiveNumber(value) {
  return !isNaN(value) && Number(value) > 0
}

export function toFixedIfDecimal(value, decimalPlaces = 0) {
  const decimalValue = Math.pow(10, decimalPlaces);
  return value % 1 === 0 ? value : Math.floor(value * decimalValue) / decimalValue;
}
export const getInitialWidthHeight = (
  naturalWidth: number,
  naturalHeight: number,
  width?: number,
  height?: number
): { width: number; height: number } => {
  const naturalImageRatio = naturalWidth / naturalHeight;
  let newSize;
  if (!width && !height) {
    newSize = { width: naturalWidth, height: naturalHeight };
  } else if (width && !height) {
    newSize = { width, height: width / naturalImageRatio };
  } else if (!width && height) {
    newSize = { width: height * naturalImageRatio, height: height };
  }
  if (newSize) {
    return newSize;
  } else {
    return { width: width , height: height };
  }
};
export const calculateImageDimensions = (updatedFormData, elementData) => {
  let width = updatedFormData?.width || elementData?.attrs?.width || elementData?.attrs?.['redactor-attributes']?.width
  if (width && !isPositiveNumber(width)) width = undefined
  let height = updatedFormData?.height || elementData?.attrs?.height || elementData?.attrs?.['redactor-attributes']?.height
  if (height && !isPositiveNumber(height)) height = undefined

  return {
    width,
    height
  }
}
 



